import { useEffect, useRef } from 'react';

/**
 * Ref para una lista scrolleable que vuelve al principio cada vez que cambia
 * cualquiera de las `deps`. Sin esto la lista queda en la posición del filtro
 * anterior y los primeros resultados del filtro nuevo aparecen fuera de la vista.
 *
 * Conviene pasar tanto el texto tipeado como los resultados: el texto resetea al
 * instante, sin esperar el debounce ni la respuesta del backend.
 */
export const useScrollReset = (...deps) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTop = 0;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return ref;
};
